import React, { useMemo } from "react";

import { Order } from "../../../../../../../services";
import { useAppContext } from "../../../../../../../context";
import { CellContentRoot } from "..";

import cellProcessing from "./cellProcessing";

const ExecutingStageWaitingCustomerTimeCellContent: React.FC<
	ExecutingStageWaitingCustomerTimeCellContent.Props
> = ({ item }) => {
	const { dateFns } = useAppContext();

	const content = useMemo(
		() => cellProcessing(item, dateFns),
		[item, dateFns],
	);

	return (
		<CellContentRoot alignItems="center" h="100%" w="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace ExecutingStageWaitingCustomerTimeCellContent {
	interface Props {
		item: Order.Model;
	}
}

export default ExecutingStageWaitingCustomerTimeCellContent;
